<div class="wrapper p-4">
    <div class="flex justify-content-between">
        <div class="flex flex-column">
            <h4 class="mb-0">{{ title}}</h4>
            <span class="text-xs text-500"
                ><br />
            </span>
        </div>
        <p-button
            icon="pi pi-times"
            [label]="'CLOSE' | translate"
            (onClick)="closeDialog()"
            severity="danger"
        />
    </div>
    <div>
        <iframe
            *ngIf="blobUrl && mimeType === 'application/pdf'"
            [src]="blobUrl"
            style="width: 100%"
            height="550"
            class="my-4"
        ></iframe>
        <img
            *ngIf="blobUrl && mimeType === 'image/png'"
            [src]="blobUrl"
            style="width: 100%; border: 3px solid gray"
            height="550"
            class="my-4"
            alt="Rendered Blob"
        />
        <img
            *ngIf="blobUrl && mimeType === 'image/jpeg'"
            [src]="blobUrl"
            style="width: 100%; border: 3px solid gray"
            height="550"
            class="my-4"
            alt="Rendered Blob"
        />
    </div>

    
    <hr class="mt-4" />
    <div class="actions-wrapper flex align-items-center gap-2 mt-4">
        <p-button
            icon="pi pi-undo"
            [label]="'CLOSE' | translate"
            (onClick)="closeDialog()"
            severity="secondary"
        />
    </div>
</div>
